import { useState } from "react"
import DoubleClickableTextLine from "./DoubleClickableTextLine"
import LayerDeleteWarnModal from "./LayerDeleteWarnModal"
import binIcon from "../../../pictures/modal_pictures/2D_editor_icon_delete_w_20x20.png"

interface RowForEditProps {
    item: Layer,
    setLayer: (layer: Layer) => void,
    removeLayer: (layer: Layer) => void
    deletable?: boolean
}

function RowForEdit({ setLayer, item, removeLayer, deletable }: Readonly<RowForEditProps>) {
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
    const deleteLayer = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setShowDeleteModal(true)
    }

    return (<>
        <li>
            <input
                className="listFlexElement"
                type="checkbox"
                onChange={b => {console.log(b.target.checked);
                 setLayer({ ...item, visibility: b.target.checked })}}
                name="visibility"
                defaultChecked={item.visibility}
            />
            <DoubleClickableTextLine
                item={item}
                layerAction={setLayer}
                setInsertNameActive={() => { }}
            />
            <button className="listFlexElement, binButton"
                disabled={!deletable} onClick={deleteLayer}>
                <img src={binIcon} alt=""></img>
            </button>

        </li>
        <LayerDeleteWarnModal
            item={item}
            setDeleteModalVisibility={setShowDeleteModal}
            showDeleteModal={showDeleteModal}
            removeLayerFromTempState={removeLayer} />
    </>
    )
}

export default RowForEdit;